import React from "react";
import { Modal, Button } from "react-bootstrap";
import {
  FaWhatsapp,
  FaEnvelope,
  FaInstagram,
  FaSkype,
  FaCopy,
} from "react-icons/fa"; // Importation des icônes
import { copyToClipboard, getCleanUrl } from "../../../../utils/functionData/otherFucntion";
import { ROUTES } from "../../../../config/routingUrl";
import { useParams } from "react-router-dom";

const ShareComponentModal = ({ show, onHide, shareUrl }) => {
  const {id , name ,description} =  useParams();


  // Vérifie si l'URL de partage est définie
  if (!shareUrl) {
    return <p>Impossible de partager cet élément.</p>;
  }

  return (
    <Modal show={show} onHide={onHide} size="sm" centered>
      <Modal.Header closeButton>
        <Modal.Title><h4>Partager </h4></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Message d'instruction */}
        <p>partager via:</p>

        {/* Liste des icônes de partage */}
        <ul style={{ display: "flex", gap: "15px", listStyle: "none", padding: 0 }}>
          {/* WhatsApp */}
          <li>
            <a
              href={`https://api.whatsapp.com/send?text=${encodeURIComponent(shareUrl)}`}
              target="_blank"
              rel="noopener noreferrer"
              title="Partager sur WhatsApp"
              style={{
                display: "inline-block",
                fontSize: "2rem",
                color: "#25D366", // Couleur WhatsApp
                transition: "transform 0.3s ease",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
              onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
              <FaWhatsapp />
            </a>
          </li>

          {/* Email */}
          <li>
            <a
              href={`mailto:?subject=Découvrez cet élément&body=${encodeURIComponent(shareUrl)}`}
              title="Partager par Email"
              style={{
                display: "inline-block",
                fontSize: "2rem",
                color: "#BB001B", // Couleur Email
                transition: "transform 0.3s ease",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
              onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
              <FaEnvelope />
            </a>
          </li>

          {/* Instagram */}
          <li>
            <a
              href={`https://www.instagram.com/?url=${encodeURIComponent(shareUrl)}`}
              target="_blank"
              rel="noopener noreferrer"
              title="Partager sur Instagram"
              style={{
                display: "inline-block",
                fontSize: "2rem",
                color: "#E1306C", // Couleur Instagram
                transition: "transform 0.3s ease",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
              onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
              <FaInstagram />
            </a>
          </li>

          {/* Skype */}
          <li>
            <a
              href={`https://join.skype.com/share?url=${encodeURIComponent(shareUrl)}`}
              target="_blank"
              rel="noopener noreferrer"
              title="Partager sur Skype"
              style={{
                display: "inline-block",
                fontSize: "2rem",
                color: "#00AFF0", // Couleur Skype
                transition: "transform 0.3s ease",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
              onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
              <FaSkype />
            </a>
          </li>

          <li>
            <a
              href={`#`}
              rel="noopener noreferrer"
              title="Copier le lien"
              style={{
                display: "inline-block",
                fontSize: "2rem",
                color: "black", // Couleur Skype
                transition: "transform 0.3s ease",
                cursor: "pointer",
              }}
              onClick={() =>{
                copyToClipboard(`${shareUrl}`)
                onHide();
              }}
            >
              <FaCopy />
            </a>
          </li>
                                                  
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" size="sm" onClick={onHide}>
          Fermer
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ShareComponentModal;